module.exports = require('./Article');